import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filterNullOrUndefined } from 'src/app/@operators/filter-null-or-undefined';
import { KioskMaintenanceDto } from 'src/app/api/models';
import { AppState } from 'src/app/state/app.state';
import { getMaintenance } from './state/maintenance.selectors';

@Component({
    selector: 'app-maintenances',
    templateUrl: './maintenances.component.html',
    styleUrls: ['./maintenances.component.scss'],
    standalone: false
})
export class MaintenancesComponent implements OnDestroy {
  public maintenance$: Observable<KioskMaintenanceDto> = this.store.pipe(select(getMaintenance));

  public textFR: SafeHtml;
  public textNL: SafeHtml;
  public textDE: SafeHtml;
  public textEN: SafeHtml;

  private subs: Subscription[] = [];

  constructor(private store: Store<AppState>, private sanitized: DomSanitizer) {
    this.subs.push(this.maintenance$.pipe(filterNullOrUndefined()).subscribe(m =>{
      this.textFR = this.sanitized.bypassSecurityTrustHtml(m.textFr);
      this.textNL = this.sanitized.bypassSecurityTrustHtml(m.textNl);
      this.textDE = this.sanitized.bypassSecurityTrustHtml(m.textDe);
      this.textEN = this.sanitized.bypassSecurityTrustHtml(m.textEn);
    }));
  }

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}
}
